"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _radio = require("baseui/radio");

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Radio = props => {
  const {
    className = '',
    overrides,
    errored,
    isError,
    labelPlacement,
    onClick,
    ...buiProps
  } = props;
  /* eslint-disable jsx-a11y/click-events-have-key-events */

  /* eslint-disable jsx-a11y/no-static-element-interactions */

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_radio.Radio, _extends({}, buiProps, {
    labelPlacement: labelPlacement ? labelPlacement : 'right',
    overrides: {
      Root: {
        style: _style.getRootStyle
      },
      Label: {
        style: _style.getLabelStyle
      },
      RadioMarkInner: {
        style: _style.getRadioMarkInnerStyle
      },
      RadioMarkOuter: {
        style: _style.getRadioMarkOuterStyle
      },
      ...(overrides || {})
    },
    isError: errored || isError
  })));
  /* eslint-enable jsx-a11y/click-events-have-key-events */

  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

var _default = Radio;
exports.default = _default;